import React from "react";
import "../css/nanny.css";
import Header from "../Headers/Header";
import HeaderLink from "../Headers/HeaderLink";
import Stepper2 from "./Steppers/Stepper2";
import MainContent from "./MainContent";
import LeftContent from "./LeftContent";
import { MdArrowBackIos } from "react-icons/md";

export default function Step3({
  currentStep,
  gotoMomKidCare,
  prev,
  errors,
  next,
  handleChange,
  selectedService,
  _next
}) {
  if (currentStep !== 3) {
    return null;
  }
  return (
    <React.Fragment>
      <div className="d-lg-block d-none">
        <Header />
      </div>
      <div className="d-lg-none d-block">
        <HeaderLink gotoMomKidCare={gotoMomKidCare} />
      </div>
      <div className="container p-lg-4 mt-lg-5 pt-lg-0 pt-5">
        <div className="row mx-auto">
          {/* Partition  one*/}
          <div className="col-lg-5 p-lg-5 pt-5 pt-lg-0">
            <LeftContent gotoMomKidCare={gotoMomKidCare} />
          </div>

          {/* Partition  second*/}
          <div className="col-lg-7 mt-2">
            {/* Right Title */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitle">
                <p className="ml-1 ml-lg-0">Please provide below information</p>
              </div>
            </div>
            {/* Right Title 2nd */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitleSecond">
                <p className="ml-1 ml-lg-0">
                  कृपया नीचे दी गई जानकारी प्रदान करें
                </p>
              </div>
            </div>

            {/* Main Content Form*/}
            <div className="row mx-lg-auto mx-0 mb-lg-0 mb-5">
              <div className="col-lg-12 mt-1 mainContent rounded">
                <div className="row p-3">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-12">
                        <div className="d-lg-none d-block">
                          <Stepper2 />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="backText d-flex align-items-center">
                          <p>
                            <MdArrowBackIos size="15" />
                            {prev}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 personal">
                    <p>
                      Service Type <span>(आप कौन सा काम कर सकते हैं)</span>
                    </p>
                  </div>
                  <div className="col-lg-12 horizontal-line">
                    <hr />
                  </div>

                  {/* Main Content */}
                  <form className="pl-0" onSubmit={(e)=>_next(e)}>
                  <MainContent handleChange={handleChange} errors={errors} selectedService={selectedService} />
                  {errors.selectedService && (
                    <span className="custom-error ml-2">
                      {errors.selectedService}
                    </span>
                  )}
                  <div className="col-lg-12 mt-4 mt-lg-5 ml-n3">
                    <div className="col ml">{next}</div>
                  </div>
                  </form>
                  <div className="d-lg-block d-none row mt-3">
                    <Stepper2 />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
